var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"zoom-image-viewer scroll-hidden"},[_c('v-img',{style:({'transform': `scale(${_vm.scale})`}),attrs:{"id":"zoom-img","src":_vm.imageUrl,"contain":"","height":_vm.imgHeight,"width":_vm.imgWidth,"position":"center center"},on:{"load":_vm.imageLoaded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }